import { createRouter, createWebHistory } from 'vue-router'
import CustomerBusiness from '@/views/CustomerBusiness.vue'
import CustomerHome from '@/views/CustomerHome.vue'
import CustomerDashboard from '@/views/CustomerDashboard.vue'
import CustomerDocuments from '@/views/CustomerDocuments.vue'
import CustomerBusinessDetails from '@/views/CustomerBusinessDetails.vue'
import CustomerMail from '@/views/CustomerMail.vue'
import CustomerUsersList from '@/views/CustomerUsersList.vue'
import CustomerSettings from '@/views/CustomerSettings.vue'
import InfoView from '@/views/InfoView.vue'
import RAHome from '@/views/RAHome.vue'
import RADashboard from '@/views/RADashboard.vue'
import RAIncomingMail from '@/views/RAIncomingMail.vue'
import RAMailRequest from '@/views/RAMailRequest.vue'
import RAUsers from '@/views/RAUsers.vue'
import RASettings from '@/views/RASettings.vue'
import RABusiness from '@/views/RABusiness.vue'
import CustomerForgotPassword from '@/views/CustomerForgotPassword.vue'
import CustomerChangePassword from '@/views/CustomerChangePassword.vue'
import AgentSettings from '@/views/AgentSettings.vue'
import CustomerTerms from '@/views/CustomerTerms.vue'
import CustomerPrivacy from '@/views/CustomerPrivacy.vue'
import CustomerOtpVerification from '@/views/CustomerOtpVerification.vue'

const routes = [
    {
        path: '/',
        name: 'Home',
        redirect: '/business-setup'
    },
    {
        path: '/customer-signin',
        name: 'CustomerSignIn',
        component: () => import('../views/CustomerSignIn.vue')
    },
    {
        path: '/otp-verification',
        name: 'OtpVerification',
        component: CustomerOtpVerification,
        meta: { requiresAuth: false }
    },
    {
        path: '/registration-success',
        name: 'RegistrationSuccess',
        component: InfoView
    },
    {
        path: '/business-setup',
        name: 'BusinessSetup',
        component: CustomerBusiness
    },
    {
        path: '/customer-home',
        name: 'CustomerHome',
        component: CustomerHome,
        meta: { requiresSetup: true },
        props: true,
        redirect: to => ({ path: '/dashboard', query: to.query }),
        children: [
            {
                path: '/dashboard/:businessId?',
                name: 'Dashboard',
                component: CustomerDashboard,
                meta: { requiresSetup: true },
                props: true
            },
            {
                path: '/business-details/:businessId?',
                name: 'BusinessDetails',
                component: CustomerBusinessDetails,
                meta: { requiresSetup: true },
                props: true
            },
            {
                path: '/documents/:businessId?',
                name: 'Documents',
                component: CustomerDocuments,
                meta: { requiresSetup: true },
                props: true
            },
            {
                path: '/mail/:businessId?',
                name: 'Mail',
                component: CustomerMail,
                meta: { requiresSetup: true },
                props: true
            },
            {
                path: '/users/:businessId?',
                name: 'Users',
                component: CustomerUsersList,
                meta: { requiresSetup: true },
                props: true
            },
            {
                path: '/settings/:businessId?',
                name: 'Settings',
                component: CustomerSettings,
                meta: { requiresSetup: true },
                props: true
            }
        ]
    },
    {
        path: '/admin/login',
        name: 'AdminLogin',
        component: () => import('../views/AdminLogin.vue')
    },
    {
        path: '/agent/login',
        name: 'AgentLogin',
        component: () => import('../views/AgentLogin.vue')
    },
    {
        path: '/agent-otp-verification',
        name: 'AgentOtpVerification',
        component: () => import('../views/AgentOtpVerification.vue')
    },
    {
        path: '/admin',
        component: () => import('../views/AdminDashboard.vue'),
        meta: { requiresAuth: true },
        children: [
            {
                path: '',
                redirect: '/admin/dashboard'
            },
            {
                path: 'dashboard',
                name: 'AdminDashboard',
                component: () => import('../views/AdminDashboard.vue')
            },
            {
                path: 'businesses',
                name: 'AdminBusinesses',
                component: () => import('../views/BusinessList.vue')
            },
            {
                path: 'business-review/:id',
                name: 'AdminBusinessReview',
                component: () => import('../views/AdminBusinessReview.vue')
            },
            {
                path: 'register-agents',
                name: 'AdminRegisterAgents',
                component: () => import('../views/RegisterAgents.vue')
            },
            {
                path: 'documents',
                name: 'AdminDocuments',
                component: () => import('../views/AdminDocuments.vue')
            }
        ]
    },
    {
        path: '/ra-home',
        name: 'RAHome',
        component: RAHome,
        meta: { requiresAuth: false },
        props: false,
        // redirect: to => ({ path: '/ra/dashboard', query: to.query }),
        children: [
            {
                path: '/ra/dashboard',
                name: 'RADashboard',
                component: RADashboard,
                meta: { requiresAuth: false },
                props: false
            },
            {
                path: '/ra/business',
                name: 'RABusiness',
                component: RABusiness,
                meta: { requiresAuth: false },
                props: false
            },
            {
                path: '/ra/business/:id',
                name: 'RABusinessDetails',
                component: () => import('../views/RABusinessDetails.vue'),
                meta: { requiresAuth: false },
                props: true
            },
            {
                path: '/ra/incoming-mail',
                name: 'RAIncomingMail',
                component: RAIncomingMail,
                meta: { requiresAuth: false },
                props: false
            },
            {
                path: '/ra/mail-request',
                name: 'RAMailRequest',
                component: RAMailRequest,
                meta: { requiresAuth: false },
                props: false
            },
            {
                path: '/ra/users',
                name: 'RAUsers',
                component: RAUsers,
                meta: { requiresAuth: false },
                props: false
            },
            {
                path: '/ra/settings',
                name: 'RASettings',
                component: RASettings,
                meta: { requiresAuth: false },
                props: false
            },
            {
                path: '/ra/settings',
                name: 'RASettings',
                component: AgentSettings,
                meta: { requiresAuth: false },
                props: false
            }
        ]
    },
    {
        path: '/forgot-password',
        name: 'CustomerForgotPassword',
        component: CustomerForgotPassword,
        meta: { requiresAuth: false }
    },
    {
        path: '/change-password',
        name: 'CustomerChangePassword',
        component: CustomerChangePassword,
        meta: { requiresAuth: false }
    },
    {
        path: '/terms',
        name: 'Terms',
        component: CustomerTerms
    },
    {
        path: '/privacy',
        name: 'Privacy',
        component: CustomerPrivacy
    }
]

const router = createRouter({
    history: createWebHistory(process.env.BASE_URL),
    routes
})

// ✅ Navigation Guard
router.beforeEach((to, from, next) => {
    // Get auth tokens and data
    const adminToken = localStorage.getItem('adminToken')
    const adminData = localStorage.getItem('adminData')
    const customerToken = localStorage.getItem('customerToken')
    const customerEmail = localStorage.getItem('customerEmail')
    const agentToken = localStorage.getItem('agentToken')
    const agentEmail = localStorage.getItem('agentEmail')
    const isSetupComplete = localStorage.getItem('isSetupComplete') === 'true'

    // Auto-login redirects 
    if (to.path === '/admin/login' && adminToken && adminData) {
        next('/admin/dashboard')
        return
    }
    if (to.path === '/customer-signin' && customerToken && customerEmail) {
        next('/dashboard')
        return
    }
    if (to.path === '/agent/login' && agentToken && agentEmail) {
        next('/ra/dashboard')
        return
    }

    // Protected route checks
    if (to.matched.some(record => record.meta.requiresAuth)) {
        if (to.path.startsWith('/admin') && !adminToken) {
            next('/admin/login')
            return
        }
        if (to.path.startsWith('/ra') && !agentToken) {
            next('/agent/login')
            return
        }
        if (!customerToken && !to.path.startsWith('/admin') && !to.path.startsWith('/ra')) {
            next('/customer-signin')
            return
        }
    }

    // Setup check for customer routes
    if (to.matched.some(record => record.meta.requiresSetup) && !isSetupComplete) {
        next('/business-setup')
        return
    }

    next()
})

export default router
